import { createTheme } from '@mui/material/styles';

const FONT_FAMILY = [
    'Montserrat',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
].join(',');

const theme = createTheme({
    typography: {
        fontFamily: FONT_FAMILY,
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                elevation1: { boxShadow: 'none', border: '1px solid #e8edf2' },
                elevation2: { boxShadow: 'none', border: '1px solid #e8edf2' },
                elevation3: { boxShadow: 'none', border: '1px solid #e8edf2' },
                elevation4: { boxShadow: 'none', border: '1px solid #e8edf2' },
                elevation6: { border: '1px solid #dde4ea' },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    '& .MuiTableRow-root': {
                        backgroundColor: '#f8fafc',
                    },
                    '& .MuiTableCell-root': {
                        fontWeight: 600,
                        color: '#4a5568',
                        borderBottom: '2px solid #e8edf2',
                        fontSize: '0.8rem',
                        letterSpacing: '0.03em',
                    },
                },
            },
        },
        MuiTableBody: {
            styleOverrides: {
                root: {
                    '& .MuiTableRow-root': {
                        transition: 'background-color 0.12s',
                    },
                    '& .MuiTableRow-root:hover': {
                        backgroundColor: '#eef5fb !important',
                    },
                    '& .MuiTableCell-root': {
                        borderBottom: '1px solid #f1f5f9',
                        color: '#374151',
                    },
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                    overflow: 'hidden',
                },
            },
        },
    },
});

export default theme;
